import { createStore } from "vuex";

export default createStore({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo") || "{}"),
    grade: sessionStorage.getItem("grade") || "三年级",
    term: sessionStorage.getItem("term") || "上学期",
    loginFlag: "",
    nowRouter: "/composition/correct"
  },
  getters: {},
  mutations: {
    SET_LOGIN: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_LOGINFLAG: (state, num) => {
      state.loginFlag = num;
    },
    SET_GRADE_TERM: (state, info) => {
      state.grade = info.grade;
      state.term = info.term;
    },
    SET_NOW_ROUTER: (state, path) => {
      state.nowRouter = path;
    }
  },
  actions: {
    setLogin({ commit }, userInfo) {
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      sessionStorage.setItem("grade", userInfo.grade);
      sessionStorage.setItem("term", userInfo.term);
      commit("SET_LOGIN", userInfo);
      commit("SET_GRADE_TERM", userInfo);
    },
    setLoginFlag({ commit }) {
      commit("SET_LOGINFLAG", new Date().getTime());
      sessionStorage.setItem("userInfo", "{}");
      sessionStorage.setItem("token", "");
      commit("SET_LOGIN", {});
    },
    setGradeTerm({ commit }, info) {
      sessionStorage.setItem("grade", info.grade);
      sessionStorage.setItem("term", info.term);
      commit("SET_GRADE_TERM", info);
    },
    setNowRouter({ commit }, path) {
      commit("SET_NOW_ROUTER", path);
    }
  },
  modules: {}
});
